export default __webpack_public_path__ + "static/media/java-script.eed4af3f.svg";